import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useMeta() {
  const { user } = useAuth();
  const canSeeUsers = ["admin", "owner", "chief"].includes(user?.role);
  const branches = useQuery({ queryKey: ["branches"], queryFn: async () => (await api.get("/branches")).data });
  const users = useQuery({
    queryKey: ["users-meta"],
    enabled: canSeeUsers,
    queryFn: async () => { try { return (await api.get("/users")).data; } catch { return []; } },
  });
  // /users/directory is open to every authenticated role (unlike /users, which is
  // admin/owner/chief-only) — this is what sales-assignment pickers should read from
  // so Manager (and any other role) always gets a working sales list.
  const directory = useQuery({ queryKey: ["users-directory"], queryFn: async () => (await api.get("/users/directory")).data });
  const master = useQuery({ queryKey: ["master"], queryFn: async () => (await api.get("/master")).data });
  const companyAddresses = useQuery({ queryKey: ["company-addresses"], queryFn: async () => (await api.get("/company-addresses")).data });
  const companySignatures = useQuery({ queryKey: ["company-signatures"], queryFn: async () => (await api.get("/company-signatures")).data });
  const bankAccounts = useQuery({ queryKey: ["company-bank-accounts"], queryFn: async () => (await api.get("/company-bank-accounts")).data });
  const companyLogo = useQuery({ queryKey: ["company-logo"], queryFn: async () => (await api.get("/settings/company-logo")).data });
  const quotationTemplate = useQuery({ queryKey: ["quotation-template"], queryFn: async () => (await api.get("/settings/quotation-template")).data });
  const documentTypes = useQuery({ queryKey: ["document-types"], queryFn: async () => (await api.get("/document-types")).data });
  const salesUsersAll = (directory.data || []).filter((u) => u.role === "sales");
  return {
    branches: branches.data || [],
    users: users.data || [],
    directory: directory.data || [],
    salesUsers: salesUsersAll,
    // Manager sees only their own branch's sales — the rest still see everyone.
    salesUsersForAssign: user?.role === "manager"
      ? salesUsersAll.filter((u) => u.branch_id === user.managed_branch_id)
      : salesUsersAll,
    master: master.data || {},
    companyAddresses: companyAddresses.data || [],
    companySignatures: companySignatures.data || [],
    bankAccounts: bankAccounts.data || [],
    companyLogoPath: companyLogo.data?.logo_path || "",
    quotationTemplate: quotationTemplate.data || null,
    documentTypes: documentTypes.data || [],
  };
}
